module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.currentExperiment.id) ? _c('div', [_vm._v("\n            Aktualnie trwa eksperyment: " + _vm._s(_vm.currentExperiment.name) + " (od " + _vm._s(_vm.currentExperiment.startDate) + ")\n            "), _c('button', {
    staticClass: "btn btn-confirm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.terminate()
      }
    }
  }, [_vm._v("Zakończ")])]) : _vm._e(), _vm._v(" "), (!_vm.currentExperiment.id) ? _c('div', [_vm._v("\n\n            Wybierz eksperyment cenowy:\n            "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedExperimentId),
      expression: "selectedExperimentId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select2",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedExperimentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.experiments), function(experiment) {
    return _c('option', {
      domProps: {
        "value": experiment.id
      }
    }, [_vm._v(_vm._s(experiment.name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-confirm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Rozpocznij eksperyment")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.results), function(value, key, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ruleName(value.rule, index)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberOrDash")(value.purchase_price)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberOrDash")(value.proposed_price)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberOrDash")(value.in_stock)))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Dzień")]), _vm._v(" "), _c('th', [_vm._v("Reguła")]), _vm._v(" "), _c('th', [_vm._v("Kupno")]), _vm._v(" "), _c('th', [_vm._v("Cena reguły")]), _vm._v(" "), _c('th', [_vm._v("Stan magazynowy")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64b639ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productDetails/PriceExperiment.vue
// module id = 1309
// module chunks = 2